import React, { FC, PropsWithChildren, useState } from 'react';
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import ArrowDownIcon from '@/components/icons/ArrowDownIcon';
import { Button, ButtonProps } from '@/components/ui/button';
import { cn } from '@/lib/utils';

type Props = {
	label?: string;
	icon?: React.FC<React.SVGProps<SVGSVGElement>>;
	showIcon?: boolean;
	buttonVariant?: ButtonProps['variant'];
	buttonSize?: ButtonProps['size'];
	buttonClassName?: string;
	containerClassName?: string;
} & PropsWithChildren;

const EDropDownMenu: FC<Props> = ({
	label,
	icon: Icon,
	children,
	showIcon = false,
	buttonVariant = 'outline',
	buttonSize,
	buttonClassName,
	containerClassName,
}) => {
	const [isOpen, setIsOpen] = useState<boolean>(false);

	const isOpenToggler = () => {
		setIsOpen((prev) => !prev);
	};

	const handleClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		isOpenToggler();
	};

	return (
		<DropdownMenu
			open={isOpen}
			onOpenChange={isOpenToggler}>
			<DropdownMenuTrigger asChild>
				<Button
					variant={buttonVariant}
					size={buttonSize}
					className={cn(buttonClassName)}>
					{Icon && <Icon />}
					{label && <span className='text-center'>{label}</span>}
					{showIcon && (
						<div
							className={`transition-transform duration-50 ease-in-out ${
								isOpen ? '-rotate-180' : 'rotate-0'
							}`}>
							{<ArrowDownIcon />}
						</div>
					)}
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent
				align='end'
				className={cn(
					'w-(--radix-dropdown-menu-trigger-width) p-0 flex flex-col gap-0 rounded-2.5xl border border-popover-100 bg-popover-10 shadow-custom',
					containerClassName,
				)}
				onClick={handleClick}>
				{children}
			</DropdownMenuContent>
		</DropdownMenu>
	);
};

export default EDropDownMenu;
